import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Card } from '@xingternal/card';
import { BodyCopy } from '@xingternal/typography';
import { StarRating } from '@xingternal/star-rating';
import { ProfileImage } from '@xingternal/profile-image';
import { getTrackingUrl } from '@xingternal/pages-tracking';

import kununuImg from '@common/assets/kununuLogo.svg';
import styles from './CompanyRecommendations.css';

const shouldRenderKununu = (kununuRating?: number) =>
  kununuRating && kununuRating > 0;

type Props = {
  profileName: string;
  numberOfRatings: number;
  link?: string;
  backgroundImageUrl?: string;
  profileImage?: string;
  kununuRating?: number;
};

const CompanyRecommendationCard = ({
  profileImage,
  backgroundImageUrl,
  profileName,
  numberOfRatings,
  kununuRating,
  link,
}: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.cardWrapper}>
      <Card
        href={getTrackingUrl({
          to: link,
          trackingKey: 'viewCompanyRecommendation',
        })}
        linkProps={{
          // @ts-ignore
          'aria-label': profileName + ' link',
        }}
        className={styles.card}
      >
        <div
          className={styles.profileBackground}
          style={
            backgroundImageUrl
              ? { backgroundImage: `url(${backgroundImageUrl}) ` }
              : {}
          }
        >
          <ProfileImage
            className={styles.profileImage}
            size="large"
            type="company"
            profileName="xing"
            src={profileImage}
          />
        </div>
        <BodyCopy
          fontWeight="bold"
          lineHeight="dense"
          className={styles.headline}
          size={'large'}
        >
          {profileName}
        </BodyCopy>
        {shouldRenderKununu(kununuRating) && (
          <>
            <BodyCopy className={styles.body}>
              <FormattedMessage
                id="CP_KUNUNU_RATED_BY"
                values={{
                  kununu_ratings_num: intl.formatNumber(numberOfRatings),
                }}
              />
              <img className={styles.kununuImg} src={kununuImg} alt="Kununu" />
            </BodyCopy>
            <StarRating rating={kununuRating} />
          </>
        )}
      </Card>
    </div>
  );
};

export default CompanyRecommendationCard;
